import React from "react";
import { Container } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CargarArchivo from "./cargar-archivo";
import CargasPrevias from "./cargas-previas";

const CargaMasivaSimple = () => {

    return(
        <Container>
            <Card className="mt-2">
                <Card.Header as="h5">Carga Masiva Simplificada</Card.Header>
                <Card.Body>
                    <CargarArchivo />
                    <CargasPrevias />
                </Card.Body>
            </Card>
            
        </Container>
    );
}

export default CargaMasivaSimple;